<script setup lang="ts">
import {ref, onMounted} from 'vue';
import ConfirmationPopup from "@/ts/Popup/ConfirmationPopup";

const show = ref<Boolean>(false);
const popupRef = ref<HTMLElement | null>(null);
const message = ref<string>('');
const instance = ConfirmationPopup.getInstance();
const closing = ref(false)
const handleConfirm = () => {
  instance.confirm()
};
const easyClosing = () => {
  closing.value = true

  setTimeout(() => {
    closing.value = false
  }, 600)
}
const handleCancel = () => {
  instance.hide();
};
onMounted(() => {
  instance.init(show, popupRef.value!, message);
  instance.addHideCallback(easyClosing);
});
</script>

<template>
  <div class="popup-wrapper" :class="{show, closing}">
    <div class="popup" ref="popupRef">
      <div class="popup__message">{{ message }}</div>
      <div class="popup__actions">
        <div class="popup__button" @click="handleCancel">Нет</div>
        <div class="popup__button error" @click="handleConfirm">Да</div>
      </div>
    </div>
  </div>
</template>

<style scoped lang="scss">
.popup-wrapper {
  display: flex;
  visibility: hidden;
  position: fixed;
  opacity: 0;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 999;
  justify-content: center;
  align-items: center;
  background-color: rgba(0, 0, 0, 0.5);
  animation: fadeOut 0.3s ease-in-out;

  .popup {
    background-color: white;
    border-radius: 30px;
    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
    padding: 30px 20px 20px 20px;
    text-align: center;
    max-width: 100%;
    width: 340px;
    box-sizing: border-box;
    transform: translateY(-20px);
    animation: slideIn 0.3s forwards;
    display: flex;
    flex-direction: column;
    gap: 30px;

    &__actions {
      display: flex;
      justify-content: space-between;
      gap: 20px;
    }

    &__button {
      width: 100%;
      height: 60px;
      display: flex;
      align-items: center;
      justify-content: center;
      border: 1px solid #363739;
      color: #363739;
      font-size: 16px;
      font-weight: 700;
      box-sizing: border-box;
      border-radius: 30px;

      &.error {
        border-color: #EF2929;
        color: #EF2929;
      }
    }
  }

  &.closing {
    visibility: visible;
  }

  &.show {
    visibility: visible;
    animation: fadeIn 0.3s ease-in-out;
    opacity: 1;

    .popup {
      animation: slideOut 0.3s forwards;
    }
  }
}

.popup__message {
  font-size: 16px;
  font-weight: 700;
}


@keyframes fadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

@keyframes fadeOut {
  from {
    opacity: 1;
  }
  to {
    opacity: 0;
  }
}

@keyframes slideIn {
  from {
    transform: translateY(-20px);
  }
  to {
    transform: translateY(0);
  }
}

@keyframes slideOut {
  from {
    transform: translateY(0);
  }
  to {
    transform: translateY(-20px);
  }
}
</style>
